
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.265","height":"14.82"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"flows","d":"M-301.18 455.072h-.655l.046-1.258a1.007 1.007 0 00-1.006-1.006h-3.422v-1.578h.695a1.559 1.559 0 001.557-1.557V447.3a1.559 1.559 0 00-1.557-1.557h-2.378a1.559 1.559 0 00-1.557 1.557v2.375a1.559 1.559 0 001.557 1.557h.694v1.578h-3.422a1.007 1.007 0 00-1.006 1.006l-.046 1.258h-.654a1.559 1.559 0 00-1.557 1.557V459a1.559 1.559 0 001.557 1.557h2.375A1.559 1.559 0 00-308.4 459v-2.376a1.559 1.559 0 00-1.558-1.557h-.729l.06-1.276h5.14l2.71.019-.046 1.258h-.735a1.559 1.559 0 00-1.557 1.557V459a1.559 1.559 0 001.557 1.557h2.376a1.559 1.559 0 001.559-1.557v-2.376a1.559 1.559 0 00-1.557-1.552zm-7.287-5.4V447.3a.571.571 0 01.57-.57h2.376a.57.57 0 01.57.57v2.375a.57.57 0 01-.57.57h-2.379a.57.57 0 01-.567-.571zm-.918 6.955V459a.571.571 0 01-.571.57h-2.375a.571.571 0 01-.57-.57v-2.376a.57.57 0 01.57-.57h2.375a.57.57 0 01.571.575zm8.775 2.373a.571.571 0 01-.57.57h-2.376a.571.571 0 01-.57-.57v-2.376a.57.57 0 01.57-.57h2.376a.57.57 0 01.57.57z","transform":"translate(313.888 -445.742)","fill":"#fff"}})])
          )
        }
      }
    